<template>
  <div v-show="isOpen" class="dialogTemplate">
    <div class="dialogMask" @click="onClickMask"></div>
    <div :class="{ isPc: !isSp, isSp: isSp }" class="dialogFrame">
      <div :class="{ isPc: !isSp }" class="dialogContent">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogTemplate',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      scrollY: undefined,
      scrollX: undefined,
    };
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
        this.scrollX = window.scrollX ? window.scrollX : window.pageXOffset;

        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.left = `-${this.scrollX}px`;
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.removeAttribute('style');
        window.scrollTo(this.scrollX, this.scrollY);
      }
    },
  },
  methods: {
    onClickMask() {
      this.$emit('click-mask', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogTemplate {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9997;

  .dialogMask {
    position: fixed;
    background: rgb(0 0 0 / 70%);
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9998;
  }

  .dialogFrame {
    padding: 20px 0;
    position: absolute;
    background: white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 80%;
    width: 90%;
    border-radius: 6px;
    z-index: 9999;

    &.isSp {
      max-width: 480px;
    }

    &.isPc {
      width: auto;
    }

    .dialogContent {
      padding: 0 20px;
      overflow: hidden;
      overflow-y: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      position: relative;

      &.isPc {
        padding: 0 72px;
      }
    }

    .dialogContent::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
